import React from 'react';
import { Check, ArrowRight, Shield, Zap, Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { includedItems, ctaVariations, marketingImages } from '../../data/mock';

const Pricing = () => {
  const handlePurchase = () => {
    // PayKings integration - opens payment link
    window.open('https://paykings.com/pay?merchant_id=wealthy_faith&amount=50', '_blank');
  };

  return (
    <section className="py-16 md:py-24 bg-teal-500 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left - Promo Image */}
            <div className="flex justify-center order-2 lg:order-1">
              <img 
                src={marketingImages.promo} 
                alt="God Has A Plan - $50 Guide"
                className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-2xl shadow-2xl shadow-black/30"
              />
            </div>

            {/* Right - Pricing Card */}
            <div className="glass-card-pricing rounded-2xl sm:rounded-3xl p-5 sm:p-6 md:p-10 order-1 lg:order-2">
              {/* Section Header */}
              <div className="text-center mb-6 sm:mb-8">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3 break-words">
                  Get Your Complete Guide Today
                </h2>
                <p className="text-white/80 text-sm sm:text-base">
                  Start building your path to financial freedom
                </p>
              </div>

              {/* Price Display */}
              <div className="text-center mb-6 sm:mb-8">
                <span className="text-5xl sm:text-6xl md:text-7xl font-bold text-white">
                  $50
                </span>
                <span className="text-lg sm:text-xl text-white/70 ml-2">USD</span>
              </div>

              {/* What's Included */}
              <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                {includedItems.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-2 sm:gap-3">
                    <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-teal-600" />
                    </div>
                    <span className="text-white text-xs sm:text-sm leading-relaxed">{item}</span>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
              <div className="text-center">
                <Button
                  onClick={handlePurchase}
                  size="lg"
                  className="w-full bg-white text-teal-600 hover:bg-white/90 text-sm sm:text-lg md:text-xl font-bold px-4 sm:px-8 py-5 sm:py-6 rounded-xl shadow-xl group"
                >
                  <span className="break-words">PURCHASE WITH PAYKINGS - $50</span>
                  <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
                </Button>

                {/* Trust Indicators */}
                <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 mt-4 sm:mt-6">
                  <div className="flex items-center gap-2 text-white/70 text-xs sm:text-sm">
                    <Shield className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span>Secure Payment</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/70 text-xs sm:text-sm">
                    <Zap className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span>Instant Delivery</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/70 text-xs sm:text-sm">
                    <Lock className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span>Money-Back Guarantee</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="mt-10 sm:mt-16 text-center px-2">
            <p className="text-white/90 text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
              {ctaVariations.value}
            </p>
            <p className="text-white/60 text-xs sm:text-sm mt-4 italic">
              P.S. Your first $50 investment could translate to $2,000-6,000 additional monthly income within 6 months. That's a 40-120x ROI.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
